/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Heading, PageContainer, Paper } from '@vaisala/rockhopper-components';
import { useProject } from '../state/project';


const HomePage = () => {
  const { setLaunched } = useProject();
  setLaunched(false)
  const { t } = useTranslation();
  return (
    <PageContainer.Content>
      <Paper>
        <Heading level={2}>{t('example_content.home_page_title')}</Heading>
        <BodyText>{t('example_content.home_page_message')}</BodyText>
      </Paper>
    </PageContainer.Content>
  );
};

export default HomePage;